import React from 'react';
import { AttachmentsList} from './components';

const Attachment = () => {
  return         <AttachmentsList />;
}

export default Attachment;
